import React from "react";
import ChooseModernOrLegacyModal from "./ChooseModernOrLegacyModal";
import { UseModernOrLegacyHook } from "./hooks";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import Modal, { ModalWidth } from "components/modal";
import { EditNewSection } from "components/MainSectionTemplate/types";
import { AxiosPromise } from "axios";

interface Props {
  useModernOrLegacyHook: UseModernOrLegacyHook;
  modalTitle: string;

  // The minimal creation screen may require some entities (bookkeepings, bank accounts etc) to be fetched from the server
  // Until that's done fetching, we should continue showing the modern or legacy modal before switching to the "minimalCreationScreen"
  isLoadingMinimalCreationScreen: boolean;

  newLabel: string;
  sections: Array<EditNewSection>;
  redirectToModernPage: (itemId: number) => void;
  redirectToLegacy: () => void;
  submit: () => AxiosPromise<server.dto.ApiResponseWrapper<any>>;
  editModalWidth?: ModalWidth
}

const ModernOrLegacy = (props: React.PropsWithChildren<Props>) => {

  const displayModernOrLegacyWhileLoading =
    props.useModernOrLegacyHook.enabled !== "onlyV2"
    && (props.useModernOrLegacyHook.screen === "minimalCreationScreen")
    && props.isLoadingMinimalCreationScreen;

  if (props.useModernOrLegacyHook.screen === "redirectToLegacy") {
    props.redirectToLegacy();
    return <></>;
  }

  if (props.useModernOrLegacyHook.screen === "chooseLegacyOrModernScreen" || displayModernOrLegacyWhileLoading) {
    return <ChooseModernOrLegacyModal
      modalTitle={props.modalTitle}
      useModernOrLegacyHook={props.useModernOrLegacyHook}
      onLegacySelected={props.redirectToLegacy}
    />;
  }
  else if (props.useModernOrLegacyHook.screen === "minimalCreationScreen" && !props.isLoadingMinimalCreationScreen) {
    return <Modal
      isOpen
      handleClose={props.useModernOrLegacyHook.onClose}
      title={props.newLabel}
      width={props.editModalWidth || "tiny"}
    >
      <div className="grow1 scrollbox-auto" >
        <EditSectionTemplate
          noPanels
          submit={props.submit}
          sections={props.sections}
          onSuccess={props.redirectToModernPage}
        />
      </div>
    </Modal>
  }

  return <></>;
};

export default ModernOrLegacy;